import React from "react";

import SweetAlert from "react-bootstrap-sweetalert";

import withStyles from "material-ui/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


class CallFormSendReport extends React.Component{
  constructor(props) {
    super(props);
    this.description = "";
  }
  
  onInputChange(evt) {
    this.description = evt.target.value;
  }

  render(){
    let body = null;
    let cancelBtnText = "Cancel";
    let showConfirm = true;
    let titleTxt = "Call Failed!";
    let bodyTxt = "Something went wrong, and an error report is generated. Send the report to help us analyze the cause of the problem.";

    if (this.props.reportType === "success") {
      titleTxt = "Want to report something?";
      bodyTxt = "Send the report to help us analyze the cause of the problem.";
    }

    if (this.props.canReportCall) {
      body = (<CustomInput
              labelText="Tell us what happened"
              id="about-me"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                multiline: true,
                rows: 5,
                onChange: this.onInputChange.bind(this)
              }}
            />);
    }
    else {
      cancelBtnText = "Done";
      showConfirm = false;
      body = (
          <small>You have reached the daily limit of reports for this pin.</small>
        );
    }

    return (
      <SweetAlert
          title=""
          onConfirm={() => this.props.onFormSendReportConfirm(this.description)}
          onCancel={() => this.props.onFormSendReportClose()}
          showConfirm={showConfirm}
          confirmBtnText="Send Report"
          showCancel
          cancelBtnText={cancelBtnText}
          className="sweet-alert"
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
        >
        <GridContainer style={{display: "flex"}}>
          <ItemGrid xs={12} sm={12}>
            <h4>{titleTxt}</h4>
            <p>{bodyTxt}</p>
          </ItemGrid>
          <ItemGrid xs={12} sm={12}>
            {body}
          </ItemGrid>
          <ItemGrid xs={12} sm={12}>
            <small>
              Note: 3 reports only per day per user
            </small>
          </ItemGrid>
        </GridContainer>
      </SweetAlert>
    );
  }
}

export default withStyles(sweetAlertStyle)(CallFormSendReport);


// WEBPACK FOOTER //
// ./src/views/callform/components/CallFormSendReport.js